import { render, staticRenderFns } from "./tesk.vue?vue&type=template&id=e885b59e&scoped=true"
import script from "./tesk.vue?vue&type=script&lang=js"
export * from "./tesk.vue?vue&type=script&lang=js"
import style0 from "./tesk.vue?vue&type=style&index=0&id=e885b59e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e885b59e",
  null
  
)

export default component.exports